/* Projects slider */
/* -------------------------------------------- */
function initProjectsSlider() {
    var carouselContainer = $('#projects-carousel-container');
    var carousel = $('.projects-carousel');
    var body = $('body');
    var slideWidth = $('.project').width();
    var threshold = 0;
    var dragStart, dragEnd;
    var category = 'school';

    // Give the second child (Middle project) the active class on initial load
    $('.project-' + category + ':nth-child(2)').addClass('active');

    // Detect arrow clicks 
    $('.projects-slider-prev').click(function(){ projectSliderShift(1, category) })
    $('.projects-slider-next').click(function(){ projectSliderShift(-1, category) })

    carousel.on('mousedown', function() {
        if (carousel.hasClass('transition')) return;

        dragStart = event.pageX;
        $(this).on('mousemove', function(){
            dragEnd = event.pageX;
            $(this).css('transform', 'translateX('+ dragPos() + 'px)');
        })
        $(document).on('mouseup', function(){
            if (dragLength() > 50 && dragEnd != 0) { 
                return projectSliderShift(1, category) 
            } else if (dragLength() < -50 && dragEnd != 0) { 
                return projectSliderShift(-1, category) 
            } else { 
                projectSliderShift(0);
            } 
            setTimeout(function() {
                carousel.removeClass('transition');
            }, 700)
        })
    });

    // Touch support
    carousel.on('touchstart', function() {
        if (carousel.hasClass('transition')) return;

        dragStart = event.touches[0].pageX;
        $(this).on('touchmove', function(){
            dragEnd = event.touches[0].pageX;
            $(this).css('transform', 'translateX('+ dragPos() + 'px)');
        })
        $(document).on('touchend', function(){
            if (dragLength() > 75 && dragEnd != 0) { 
                dragStart = 0;
                dragEnd = 0;
                return projectSliderShift(1, category) 
            } else if (dragLength() < -75 && dragEnd != 0) { 
                dragStart = 0;
                dragEnd = 0;
                return projectSliderShift(-1, category) 
            } else { 
                dragStart = 0;
                dragEnd = 0;
                projectSliderShift(0);
            } 
            setTimeout(function() {
                carousel.removeClass('transition');
            }, 700)
        })
    });

    carousel.on('touchcancel', function() {
        return artworkSliderShift(0);
    });

    function dragPos() {
        return dragEnd - dragStart;
    }

    function dragLength() {
        return dragEnd - dragStart;
    }

    function projectSliderShift(direction, category) {
        if (carousel.hasClass('transition')) return;

        category = category;

        $(document).off('mouseup')
        carousel.off('mousemove')
                .addClass('transition')
                .css('transform', 'translateX(' + (direction * slideWidth) + 'px)');

        $(document).off('touchend')
        carousel.off('touchmove')
                .addClass('transition')
                .css('transform', 'translateX(' + (direction * slideWidth) + 'px)');

        if (carouselContainer.hasClass('projects-' + category + '-active')) {
            setTimeout(function() {
                if (direction === 1) {
                    $('.project-' + category + ':first').before($('.project-' + category + ':last'));
                } else if (direction === -1) {
                    $('.project-' + category + ':last').after($('.project-' + category + ':first'));
                }
                carousel.removeClass('transition');
                carousel.css('transform', 'translateX(0px)');
            }, 700)

            if (direction === 1) {
                $('.project-' + category + '').removeClass('active');
                $('.project-' + category + ':nth-child(1)').addClass('active');
            } else if (direction === -1) {
                $('.project-' + category + '').removeClass('active');
                $('.project-' + category + ':nth-child(3)').addClass('active');
            }
        } 
    }

    /* Onclick, change category */
    $('.projects-button-school').click(function(){ projectChangeCategory('school') })
    $('.projects-button-personal').click(function(){ projectChangeCategory('personal') })

    function projectChangeCategory(categorySwitch) {
        category = categorySwitch;
        carouselContainer.removeClass('projects-personal-active projects-school-active').addClass('projects-' + categorySwitch + '-active');
        $('.projects-button-personal div, .projects-button-school div').removeClass('active');
        $('.projects-button-' + category + ' div').addClass('active');
        // Add active on second child again   
        $('.project-' + category + ':nth-child(2)').addClass('active');

        // Change theme to dakr on personal category
        if (carouselContainer.hasClass('projects-personal-active')) {
            body.removeClass('bg-light').addClass('bg-dark');
        } else {
            body.removeClass('bg-dark').addClass('bg-light');;
        }
        // Pass changed category into projectSliderShift()
        projectSliderShift(0, category);
    }

    /* On resize, re-adjust sizes */
    $(window).resize(function() {
        slideWidth = $('.project').width();
    });
}

initProjectsSlider();
